import _extends from "@babel/runtime/helpers/extends";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { TextInput } from "..";
import { EyeToggle } from "./components";
/**
 * @typedef {import("../text-input/TextInput").TextInputProps &
 *  { type?: "password" | "text", onToggle?: (type: "password" | "text") => any } &
 *  { ref: import("react").Ref<HTMLInputElement> } &
 *  { [key: string]: any }
 * } PasswordInputProps
 */

/**
 * @type {React.FC<PasswordInputProps>}
 */

export const PasswordInput = /*#__PURE__*/React.forwardRef(function PasswordInput({
  onToggle,
  ...props
}, ref) {
  /** @type {["password" | "text", React.Dispatch<React.SetStateAction<"password" | "text">>]} */
  const [toggleState, setToggleState] = useState("password");
  useEffect(() => {
    if (props.type) {
      setToggleState(props.type);
    }
  }, []);
  const isPassword = toggleState === "password";

  const toggle = () => {
    setToggleState(isPassword ? "text" : "password");
    typeof onToggle === "function" && onToggle(isPassword ? "text" : "password");
  };
  /** @type {ReactState<boolean>} */


  const [hasText, setHasText] = useState(false);
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    type: toggleState,
    ref: ref,
    className: classNames(props.className, "relative"),
    onChange: e => {
      setHasText(!!e.target.value.length);
      typeof props.onChange === "function" && props.onChange(e);
    }
  }), hasText ? /*#__PURE__*/React.createElement("button", {
    type: "button",
    role: "switch",
    className: classNames("password-toggle h-full w-12 text-center justify-center items-center border-2 rounded border-transparent", {
      "focus:outline-none focus:border-en-yellow-700": props.valid !== false && hasText,
      "focus:outline-none focus:border-en-red": props.valid === false
    }),
    onClick: toggle,
    "aria-pressed": isPassword ? "false" : "true"
  }, isPassword ? /*#__PURE__*/React.createElement(EyeToggle, {
    fill: "#909090"
  }) : /*#__PURE__*/React.createElement(EyeToggle, {
    fill: "#000000"
  })) : null);
});
PasswordInput.defaultProps = {
  onToggle: () => {}
};
PasswordInput.propTypes = {
  className: PropTypes.any,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
  readOnly: PropTypes.bool,
  type: PropTypes.any,
  onToggle: PropTypes.func
};
export * from "./components";